import React from "react";
import useCompositionBoard from "../../../hooks/useCompositionBoard";
import "./CompositionBoard.scss";
// import chairmanImage from "../../../assets/About/chairman.png";
import chairmanImage from "../../../assets/About/new-chairman.jpeg";
import ceoImg2 from "../../../assets/About/rupali-ceo.jpeg";
import boardImg from "../../../assets/board-bg.png";

const CompositionBoard = () => {
  const [boardInfo, setBoardInfo, loading] = useCompositionBoard();

  // console.log("boardInfo", boardInfo);

  const chairman = boardInfo.filter((person) => person.Type === "Chairman");
  const ceo = boardInfo.filter(
    (person) => person.Type === "Chief Executive Officer",
  );
  const audit = boardInfo.filter((person) => person.Type === "Audit Committee");

  const nrc = boardInfo.filter((person) => person.Type === "NRC Committee");

  const director = boardInfo.filter((person) => person.Type === "Directors");

  const investment = boardInfo.filter(
    (person) => person.Type === "Investment Committee",
  );

  const riskManagement = boardInfo.filter(
    (person) => person.Type === "Risk Management Committee",
  );
  const policyholderProtectionCompliance = boardInfo.filter(
    (person) =>
      person.Type === "Policyholder Protection & Compliance Committee",
  );

  // console.log(
  //   "investment",
  //   investment,
  //   riskManagement,
  //   policyholderProtectionCompliance
  // );

  return (
    <>
      <div className="composition_board">
        <div
          className="composition_board_bg"
          style={{ backgroundImage: `url(${boardImg})` }}
          data-aos="zoom-in"
        ></div>

        <div className="container-fluid p-0">
          <div className="heading_box">Composition of Board & Committee</div>

          <div className="board_content">
            <div className="container">
              <div className="chairman_content">
                <div className="row justify-content-between">
                  <div className="col-lg-7 left">
                    {loading ? (
                      <>
                        {chairman.map((board, index) => (
                          <div key={index}>
                            <h4>{board.Title}</h4>
                            <h5>{board.Name}</h5>

                            <p className="text-justify">
                              Mr. Mostafa Quamrus Sobhan is a distinguished
                              Bangladeshi entrepreneur, business leader, and
                              diplomat with extensive experience in
                              international trade, manufacturing, financial
                              services, corporate governance, and investment
                              management. He currently serves as the Chairman of
                              Rupali Insurance Company Limited, Managing
                              Director of Dragon Sweater and Spinning Limited,
                              and Honorary Consul of the Oriental Republic of
                              Uruguay in Bangladesh. <br />
                              A graduate of Nottingham Trent University, United
                              Kingdom, Mr. Sobhan holds a Bachelor of Business
                              Administration (BBA) degree and has built a
                              successful career spanning more than two decades
                              in the export-oriented manufacturing sector. Under
                              his leadership, Dragon Group has strengthened its
                              position as one of Bangladesh’s leading sweater
                              and textile manufacturing enterprises, serving
                              renowned international brands across Europe, North
                              America, and other global markets. <br />
                              Mr. Sobhan possesses extensive expertise in
                              strategic business management, export development,
                              international marketing, corporate governance, and
                              organizational leadership. He has played a pivotal
                              role in expanding business operations, enhancing
                              operational efficiency, developing international
                              partnerships, and driving sustainable growth
                              across multiple sectors including textiles,
                              insurance, real estate, and financial services. In
                              addition to his corporate responsibilities, Mr.
                              Sobhan has represented Bangladesh and his business
                              interests at numerous international trade forums,
                              diplomatic engagements, business conferences, and
                              investment missions across Europe, North America,
                              Asia, and Oceania. His global exposure and
                              international network have contributed
                              significantly to strengthening commercial
                              relations between Bangladesh and overseas markets.{" "}
                              <br />
                              Mr. Sobhan serves on the boards of several public
                              and private sector organizations, where he
                              contributes to policy formulation, strategic
                              planning, investment oversight, risk management,
                              and corporate governance. He is also actively
                              involved in entrepreneurship development
                              initiatives, educational institutions, and
                              industry associations, promoting innovation,
                              leadership, and sustainable business practices.{" "}
                              <br />
                              In recognition of his contributions to
                              international business relations and bilateral
                              cooperation, he was appointed Honorary Consul of
                              Uruguay in Bangladesh. Through this role, he has
                              actively worked to promote trade, investment,
                              cultural exchange, and diplomatic engagement
                              between Bangladesh and Uruguay. <br />
                              Known for his forward-looking vision, strong
                              leadership, and commitment to excellence, Mr.
                              Sobhan continues to contribute to the growth of
                              Bangladesh’s private sector while fostering
                              international partnerships and supporting social
                              and community development initiatives. His
                              leadership, business acumen, and global outlook
                              remain instrumental in shaping the long-term
                              strategic direction and sustainable growth of the
                              organizations he serves.
                            </p>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center my-5">
                        <button className="btn btn-danger w-50" type="button">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-5 order-first my-auto order-lg-last">
                    <div className="right">
                      <div className="chairman_content_box">
                        {/* <div className="line_rotate"></div> */}
                        <div className="chairman_img">
                          <img
                            src={chairmanImage}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="others_content">
              <div className="container">
                <div className="ceo_content_box">
                  <div className="row justify-content-between">
                    <div className="col-lg-5 mb-lg-0 mb-5">
                      <div className="ceo_left">
                        <img
                          src={ceoImg2}
                          className="img-fluid ceo_img"
                          alt=""
                        />
                        <h5>{ceo[0]?.Name}</h5>
                        <h6>{ceo[0]?.Title} (In-charge)</h6>
                      </div>
                    </div>
                    <div className="col-lg-7 my-auto">
                      {loading ? (
                        <div className="ceo_right">
                          <div className="ceo_content">
                            {ceo.map((board, index) => (
                              <div key={index}>
                                <h4>{board.Title} (In-charge)</h4>
                                <h5
                                  style={{
                                    color: "#cf173c",
                                    fontFamily: "Inter",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  <b>{board.Name}</b>
                                </h5>

                                <p className="text-justify">
                                  Mr. A. H. M. Abul Khair is the Chief Executive
                                  Officer (In-Charge) of Rupali Insurance
                                  Company Limited. He holds Bachelor’s Honours
                                  and Master’s degrees in Political Science from
                                  the University of Chittagong and has been
                                  associated with the insurance industry for
                                  more than three decades. Prior to joining
                                  Rupali Insurance in July 1988, he served with
                                  Eastern Insurance Company Limited and Eastland
                                  Insurance Company Limited. <br />
                                  Since joining Rupali Insurance, Mr. Abul Khair
                                  has served the Company with dedication,
                                  integrity and professional distinction. Over
                                  the years, he held various responsible
                                  positions and was eventually promoted to
                                  Additional Managing Director. Before assuming
                                  the responsibility of Chief Executive Officer
                                  (In-Charge), he served for many years as
                                  In-Charge of the Company’s Agrabad Branch,
                                  where he demonstrated strong leadership,
                                  strengthened business relationships and
                                  consistently achieved impressive business
                                  performance. <br />
                                  Mr. Abul Khair possesses extensive experience
                                  in business development, underwriting, claims
                                  administration, reinsurance and branch
                                  operations. His practical knowledge,
                                  disciplined leadership and commitment to
                                  institutional growth have earned him the
                                  confidence of management, colleagues, clients
                                  and stakeholders. He has also participated in
                                  professional training programmes, including
                                  the Programme on Management of Rural Insurance
                                  conducted by the National Insurance Academy,
                                  Pune, India. <br />
                                  With continued focus on underwriting
                                  discipline, claims service, client retention
                                  and sustainable business growth, Mr. Abul
                                  Khair continues to guide Rupali Insurance
                                  Company Limited with professionalism,
                                  stability and a clear commitment to long-term
                                  value creation.
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="text-center my-5">
                          <button className="btn btn-danger w-50" type="button">
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 ">
                    <div className="left">
                      {/* <div className="ceo_content">
                        {ceo.map((board, index) => (
                          <div key={index}>
                            <h4>{board.Title}</h4>
                            <h5
                              style={{ color: "#cf173c", fontFamily: "Inter" }}
                            >
                              <b>{board.Name}</b>
                            </h5>
                          </div>
                        ))}
                      </div> */}
                      <div className="director_content">
                        <h4>Directors</h4>
                        {director.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 my-5 my-lg-0">
                    <div className="right">
                      <div className="audit_content committee_content">
                        <h4>Audit Committee</h4>
                        {audit.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="nrc_content committee_content">
                        <h4>NRC Committee</h4>
                        {nrc.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Investment Committee</h4>
                        {investment.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Risk Management Committee</h4>
                        {riskManagement.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Policyholder Protection & Compliance Committee</h4>
                        {policyholderProtectionCompliance.map(
                          (board, index) => (
                            <div key={index} className="row">
                              <div className="col-8">
                                <p>
                                  <b>{board.Name}</b>
                                </p>
                              </div>
                              <div className="col-4">
                                <p>{board.Title}</p>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompositionBoard;
